import { styled } from '../theme';

export const Wrapper = styled('div', {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '16px 24px',
});
